import { Component, ViewChild } from '@angular/core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';

@Component({
  selector: 'app-success-story',
  templateUrl: './success-story.component.html',
  styleUrl: './success-story.component.scss'
})
export class SuccessStoryComponent {

  carouselData = [
    {
      title: 'ما هو الجديد',
      desc: 'محافظة كفر الشيخ و الهيئة العامة للإستثمار يسرهما الإعلان عنطرح قطع أراضى شاغرة للإستثمار..تتقدم الشركات أو الأفراد بطلباتالحجز إلى مكتب الهيئة العامة للإستثمار بديوان عام محافظة كفرمحافظة كفر الشيخ و الهيئة العامة للإستثمار يسرهما الإعلان عنطرح قطع أراضى شاغرة للإستثمار..تتقدم الشركات أو الأفراد بطلباتالحجز إلى مكتب الهيئة العامة للإستثمار بديوان عام محافظة كفر',
      image: '../../../assets/carouselSu.png',
    },
    {
      title: 'ما هو الجديد',
      desc: 'محافظة كفر الشيخ و الهيئة العامة للإستثمار يسرهما الإعلان عنطرح قطع أراضى شاغرة للإستثمار..تتقدم الشركات أو الأفراد بطلباتالحجز إلى مكتب الهيئة العامة للإستثمار بديوان عام محافظة كفرمحافظة كفر الشيخ و الهيئة العامة للإستثمار يسرهما الإعلان عنطرح قطع أراضى شاغرة للإستثمار..تتقدم الشركات أو الأفراد بطلباتالحجز إلى مكتب الهيئة العامة للإستثمار بديوان عام محافظة كفر',
      image: '../../../assets/carouselSu.png',
    },
    {
      title: 'ما هو الجديد',
      desc: 'محافظة كفر الشيخ و الهيئة العامة للإستثمار يسرهما الإعلان عنطرح قطع أراضى شاغرة للإستثمار..تتقدم الشركات أو الأفراد بطلباتالحجز إلى مكتب الهيئة العامة للإستثمار بديوان عام محافظة كفرمحافظة كفر الشيخ و الهيئة العامة للإستثمار يسرهما الإعلان عنطرح قطع أراضى شاغرة للإستثمار..تتقدم الشركات أو الأفراد بطلباتالحجز إلى مكتب الهيئة العامة للإستثمار بديوان عام محافظة كفر',
      image: '../../../assets/carouselSu.png',
    },
  ];

  @ViewChild('slickModal', { static: true }) slickModal?: SlickCarouselComponent;

  slideConfig: any;

  constructor() {
    this.setSliderConfig();
  }

  setSliderConfig() {
    this.slideConfig = {
      rtl: true,
      dots: false,
      autoplay: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed: 4000,
      arrows: false,
      centerMode: false,   
      variableWidth: false 
    };
  }

  moveSlider(next: boolean) {
    if (next) {
      this.slickModal?.slickNext();
    } else {
      this.slickModal?.slickPrev();
    }
  }
}